import React from 'react';
import openbankLogo from 'assets/icons/logo-02.svg';

export const Logo = () => {
    return (
        <div className="col-xs-6 legal-info__doc-block-logo">
            <img src={openbankLogo} width={150} alt="openbank logo" />
        </div>
    );
};
